import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import "./QueueHeaderTooltip.css";

const QueueHeaderTooltip = ({ title, children, wide, placement, block }) => {
  const [open, setOpen] = useState(false);
  const [coords, setCoords] = useState({ top: 0, left: 0 });
  const anchorRef = useRef(null);
  const placeRight = placement === "right";

  const updatePosition = () => {
    const node = anchorRef.current;
    if (!node) {
      return;
    }
    const rect = node.getBoundingClientRect();
    if (placeRight) {
      setCoords({
        top: rect.top + rect.height / 2,
        left: rect.right + 10,
      });
      return;
    }
    setCoords({
      top: rect.bottom + 8,
      left: rect.left + rect.width / 2,
    });
  };

  const show = () => {
    updatePosition();
    setOpen(true);
  };

  const hide = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (!open) {
      return undefined;
    }
    const onMove = () => updatePosition();
    window.addEventListener("resize", onMove);
    window.addEventListener("scroll", onMove, true);
    return () => {
      window.removeEventListener("resize", onMove);
      window.removeEventListener("scroll", onMove, true);
    };
  }, [open, placeRight]);

  return (
    <span
      ref={anchorRef}
      className={
        "queue-header-tooltip-wrap" +
        (block ? " is-block" : "") +
        (wide ? " is-wide-wrap" : "")
      }
      onMouseEnter={show}
      onMouseLeave={hide}
      onFocus={show}
      onBlur={hide}
    >
      {children}
      {open && title
        ? ReactDOM.createPortal(
            <div
              className={
                "queue-header-tooltip" + (wide ? " is-wide" : "")
              }
              style={{
                top: coords.top,
                left: coords.left,
                transform: placeRight
                  ? "translateY(-50%)"
                  : "translateX(-50%)",
              }}
              role="tooltip"
            >
              {title}
            </div>,
            document.body
          )
        : null}
    </span>
  );
};

QueueHeaderTooltip.propTypes = {
  title: PropTypes.node,
  children: PropTypes.node,
  wide: PropTypes.bool,
  placement: PropTypes.string,
  block: PropTypes.bool,
};

QueueHeaderTooltip.defaultProps = {
  title: "",
  children: null,
  wide: false,
  placement: "bottom",
  block: false,
};

export default QueueHeaderTooltip;



// WEBPACK FOOTER //
// ./src/components/workflowQueue/QueueHeaderTooltip.js